/** @jsxImportSource @emotion/react */

import { useState } from "react";
import { css } from "@emotion/react";
import UI from "@mile-meeting/mile-ui";
import { useLocation, useNavigate } from "react-router-dom";
import BasicSignUp from "./basic-sign-up";
import BackBtn from "../component/back-btn";
import GoogleSignup from "./google-sign-up";
import { checkExistingUserByEmail } from "apis/auth/sign-up";
import AlertModal from "uis/modal/alert-modal";
import { googleLogin } from "apis/google";
import { useToast } from "hook/useToast";

const Signup = () => {
  const { showToast } = useToast();
  const location = useLocation();
  const navigate = useNavigate();
  const code = new URLSearchParams(location.search).get("code")?.replace(/\s/g, "+") ?? null;
  const [googleSignup, setGoogleSignup] = useState<boolean>(false);
  const [email, setEmail] = useState<string>();
  const [googleAccessToken, setGoogleAccessToken] = useState<string>();

  const [showLoginAlertModal, setShowLoginAlertModal] = useState<boolean>(false);
  const [showGoogleAlertModal, setShowGoogleAlertModal] = useState<boolean>(false);

  const redirectGoogleSignup = async (email: string, accessToken: string) => {
    const res = await checkExistingUserByEmail(email);
    if (res.success) {
      if (res.isExisted) {
        if (res.loginProvider === "MILE") setShowLoginAlertModal(true);
        else setShowGoogleAlertModal(true);
      } else {
        setGoogleSignup(true);
        setEmail(email);
        setGoogleAccessToken(accessToken);
      }
    } else {
      showToast("처리 중 오류가 발생했습니다. 다시 시도해주세요", "warning");
    }
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", flex: 1 }}>
      <UI.Navigation.TopNav onClickLogo={() => navigate("/login")} />
      <BackBtn onClick={() => (window.location.href = "/login")} />
      {!googleSignup && <BasicSignUp code={code} redirectGoogleSignup={redirectGoogleSignup} />}
      {googleSignup && email && googleAccessToken && (
        <GoogleSignup code={code} email={email} accessToken={googleAccessToken} />
      )}
      <AlertModal
        title="구글로 가입된 이메일입니다."
        btnTitle="구글로 로그인하기"
        onChange={googleLogin}
        modalIsOpen={showGoogleAlertModal}
        closeModal={() => setShowGoogleAlertModal(false)}
      />
      <AlertModal
        title="이미 가입된 이메일입니다."
        btnTitle="로그인 하러 가기"
        onChange={() => (window.location.href = "/login")}
        modalIsOpen={showLoginAlertModal}
        closeModal={() => setShowLoginAlertModal(!showLoginAlertModal)}
      />
    </div>
  );
};

export default Signup;
